<template>
  <form
    ref="form"
    data-url="/qualityManagement/preparationCertificate/annexes"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12">
        <table class="table table-sm table-striped" v-if="inputs.status == 156">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="align-middle">
                Resolución Suscrita por el Director Ejecutivo
              </td>
              <td class="align-middle">
                {{
                  inputs.subscribed_accreditation_resolution
                    ? `${inputs.subscribed_accreditation_resolution.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.subscribed_accreditation_resolution
                    ? `${inputs.subscribed_accreditation_resolution.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'subscribed_accreditation_resolution')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <!-- <tr>
              <td class="align-middle">Plan de Mantenimiento</td>
              <td class="align-middle">
                {{
                  inputs.subscribed_accreditation_resolution
                    ? `${inputs.subscribed_accreditation_resolution.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.subscribed_accreditation_resolution
                    ? `${inputs.subscribed_accreditation_resolution.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'maintenance_plan')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
            <!-- <tr>
              <td class="align-middle">Alcances</td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'scope_607')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </div>

    <div>
      <div class="alert alert-warning mt-3" role="alert" v-if="!inputs.certificate_accreditation_symbol">
        Verifique la información guardada en "Datos Releevantes" sean los correctos antes de generar el certificado.
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-3">
        <button
          type="submit"
          class="btn btn-success"
          v-if="!inputs.certificate_accreditation_symbol"
          @click.prevent="openCertificatePDF()"
        >
          Generar Certificado PDF
        </button>
        <a
          type="submit"
          class="btn btn-success"
          v-if="inputs.certificate_accreditation_symbol"
          :href="`${inputs.certificate_accreditation_symbol.full_url}`"
          target="_blank"
        >
          Ver Certificado
        </a>
        
        <button
            type="submit"
            class="btn btn-success"
            @click.prevent="openPdfScopes()"
        >
          Generar Anexo de Alcances
        </button>

        <button
          type="button"
          class="btn btn-info"
          v-if="inputs.certificate_accreditation_symbol && inputs.status == 54"
          @click.prevent="sendCertificate"
        >
          Enviar Certificado
        </button>
        <button
            type="submit"
            class="btn btn-warning"
            v-if="inputs.certificate_accreditation_symbol && inputs.status == 54"
            @click.prevent="historicalCaertificate()"
        >
          Limpiar Certificado
        </button>
        <!-- <button
          type="submit"
          class="btn btn-success"
          @click.prevent="openWord()"
        >
          Generar Certificado Word
        </button> -->
      </div>
      <div class="col-12">
        <legend class="col-12 col-form-label text-primary pt-0 mb-3">
          <h5>Carga de Documentos</h5>
        </legend>
      </div>

      <!-- <div class="col-6">
        <div class="form-group">
          <label
            >Copia Certificado de Acreditación
            <b class="text-danger">*</b></label
          >
          <app-input
            type="file"
            :label="inputs.file ? inputs.file.name : $t('upload_your_file')"
            v-model="inputs.file"
            :required="true"
            v-if="!inputs.certificate_accreditation_symbol"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="
                openTab(inputs, 'certificate_accreditation_symbol')
              "
              v-if="inputs.certificate_accreditation_symbol"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="
                openDeleteModal('certificate_accreditation_symbol')
              "
              v-if="inputs.certificate_accreditation_symbol"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div> -->

      <div class="col-6">
        <div class="form-group">
          <label>Símbolo de Acreditación <b class="text-danger">*</b></label>
          <app-input
            type="file"
            :label="
              inputs.file_symbol
                ? inputs.file_symbol.name
                : $t('upload_your_file')
            "
            v-model="inputs.file_symbol"
            :required="true"
            v-if="!inputs.accreditation_symbol"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="openTab(inputs, 'accreditation_symbol')"
              v-if="inputs.accreditation_symbol"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="openDeleteModal('accreditation_symbol')"
              v-if="inputs.accreditation_symbol"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>

    <director-area-modal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiUrl";
import { axiosPost } from "@/app/helpers/AxiosHelper";

export default {
  mixins: [FormMixin],

  data() {
    return {
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      preloader: false,
      inputs: {},
      deleteModal: false,
      selected: "",
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    data() {
      let url = `${actions.QUALITY_MANAGEMENT}/preparationCertificate/show?accAppId=${this.$store.state.accreditation.id}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
      });
    },

    openPDF() {
      let w;
      w = window.open(
        `${actions.QUALITY_MANAGEMENT}/preparationCertificate/generatepdf?accAppId=${this.$store.state.accreditation.id}`,
        "_blank"
      );
      if (w) {
        w.onload = () => {
          this.data();
        };
        w.focus();
      } else {
        this.data();
      }
      
    },

    openCertificatePDF() {
      let w;
      w = window.open(
        `${actions.QUALITY_MANAGEMENT}/preparationCertificate/generate-certificate?accAppId=${this.$store.state.accreditation.id}`,
        "_blank"
      );
      if (w) {
        w.onload = () => {
          this.data();
        };
        w.focus();
      } else {
        this.data();
      }
    },

    openPdfScopes(){
      const w = window.open(
          `/common/scopes/exportActiveScopes?type=pdf&accAppId=${this.$store.state.accreditation.id}&tableName=active`,
        '_blank'
      );
      w.focus();
    },
    openWord() {
      let w;
      w = window.open(
        `${actions.QUALITY_MANAGEMENT}/preparationCertificate/generateWord?accAppId=${this.$store.state.accreditation.id}`
      );
      w.focus();
    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      this.isAddEditModalActive = false;
    },

    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.inputs = data;
      this.$toastr.s(this.$t("updated_success"));
      this.data();
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    sendCertificate() {
      this.preloader = true;
      if (!this.inputs.certificate_accreditation_symbol || !this.inputs.accreditation_symbol) {
        this.$toastr.e("suba el documento Símbolo de Acreditación");
        return ;
      }
      let urlEmail = `/qualityManagement/preparationCertificate/sendMailCertificate`;
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }

      axiosPost(urlEmail, formData)
        .then((res) => {
          if (res.status == 200) {
            this.$toastr.s("Certificado enviado al OEC");
          } else {
            this.$toastr.s("Error");
          }
        })
        .catch(({ error }) => {
          this.$toastr.e(res.data.message);
        })
        .finally(() => {
          this.data();
          this.preloader = false;
        });

    },
    historicalCaertificate() {
      this.preloader = true;
      let acc_app_id = this.$store.state.accreditation.id;
      let url = `/qualityManagement/preparationCertificate/historical-certificates?accAppId=${this.$store.state.accreditation.id}`;
      axiosPost(url)
        .then((res) => {
          if (res.status == 200) {
            this.$toastr.s(res.data.message);
          } else {
            this.$toastr.s("Error");
          }
        })
        .catch(({ error }) => {
          this.$toastr.e(res.data.message);
        })
        .finally(() => {
          this.data();
          this.preloader = false;
        });
    },
  },
};
</script>